import React from 'react';
import { CertificateType } from '../../typings/WindowEnvironmentProperties';
import { StateOpt } from '../components/Address/address.constants';
import { Cooling } from '../components/Icons/GraphicalSelect/Cooling';
import { NoCooling } from '../components/Icons/GraphicalSelect/NoCooling';
import { NoIcon } from '../components/Icons/GraphicalSelect/NoIcon';
import { YesHeatedIcon } from '../components/Icons/GraphicalSelect/YesHeatedIcon';
import { YesNotHeatedIcon } from '../components/Icons/GraphicalSelect/YesNotHeatedIcon';
import { OBERSTE_GESCHOSSDECKE, SONSTIGES, WAERMEERZEUGER, WAERMEVERTEILUNG_ABGABE } from './recommendationTypes';

export type OptionsType = {
  id: string;
  label: string;
  value?: string;
  error?: boolean;
};

export interface GraphicalSelectOption extends OptionsType {
  icon: JSX.Element;
  additionalLabel?: JSX.Element;
}

export const addressStateOptions: OptionsType[] = StateOpt.map<OptionsType>((state) => ({
  id: state,
  value: state,
  label: state,
}));

export const enhancementsOptions = () => {
  const options = [
    { id: '1', label: 'Anbau', value: 'Anbau' },
    { id: '2', label: 'Erweiterung', value: 'Erweiterung' },
    { id: '3', label: 'Aufstockung', value: 'Aufstockung' },
    { id: '4', label: 'Dachausbau', value: 'Dachausbau' },
    { id: '5', label: 'Wintergarten', value: 'Wintergarten' },
  ];
  if (window?.ea48?.certificateType === CertificateType.CONSUMPTION) {
    return [
      ...options,
      { id: '6', label: 'Kernsanierung', value: 'Kernsanierung' },
      { id: '7', label: 'Modernisierung', value: 'Modernisierung' },
    ];
  }
  return options;
};

export const recommendationsOptions = {
  recommendation_1: {
    label:
      'Prüfung, ob eine nachträgliche Dämmung der obersten Geschossdecke oder der Dachkonstruktion technisch möglich und wirtschaftlich sinnvoll ist.',
    type: SONSTIGES,
  },
  recommendation_2: {
    label:
      'Prüfung, ob eine nachträgliche Dämmung von unzureichend gedämmten wärmeübertragenden Umfassungsflächen technisch möglich und wirtschaftlich sinnvoll ist.',
    type: SONSTIGES,
  },
  recommendation_3: {
    label:
      'Prüfung, ob ein Austausch der Fenster durch Fenster mit deutlich besserem U-Wert technisch möglich und wirtschaftlich sinnvoll ist.',
    type: SONSTIGES,
  },
  recommendation_4: {
    label: 'Thermografische Untersuchung der Gebäudehülle durch einen Fachingenieur oder zertifizierten Messtechniker.',
    type: SONSTIGES,
  },
  recommendation_5: {
    label: 'Gebäudehülle: Expertenrat vor Ort, ingenieurtechnische Energieberatung vor Ort.',
    type: SONSTIGES,
  },
  recommendation_6: {
    label: 'Gebäudehülle: Prüfung, ob eine Dämmung der Kellerdecke technisch möglich und wirtschaftlich sinnvoll ist.',
    type: SONSTIGES,
  },
  recommendation_7: {
    label: 'Prüfung, ob eine Nutzung von erneuerbaren Energien technisch möglich und wirtschaftlich sinnvoll ist.',
    type: SONSTIGES,
  },
  recommendation_8: {
    label: 'Anlagentechnik: Expertenrat vor Ort, ingenieurtechnische Energieberatung vor Ort.',
    type: SONSTIGES,
  },

  recommendation_9: {
    label:
      'Prüfung, ob eine Nachrüstpflicht gemäß GEG § 47 (1), (2) oder (3) für die Dämmung der obersten Geschossdecke besteht.',
    type: OBERSTE_GESCHOSSDECKE,
  },

  recommendation_10: {
    label: 'Prüfung, ob eine Modernisierung der Heizungsanlage technisch möglich und wirtschaftlich sinnvoll ist.',
    type: WAERMEERZEUGER,
  },
  recommendation_11: {
    label:
      'Prüfung, ob für den bestehenden Heizkessel, Wärmeerzeuger oder für vorhandene Einzelöfen eine Austauschpflicht gemäß GEG § 72 (1) oder (2) besteht. Hierzu bitte Kontakt mit dem zuständigen Bezirksschornsteinfeger aufnehmen.',
    type: WAERMEERZEUGER,
  },
  recommendation_12: {
    label:
      'Prüfung, ob eine Einrichtung einer zentralen Warmwasserbereitung technisch möglich und wirtschaftlich sinnvoll ist.',
    type: WAERMEERZEUGER,
  },
  recommendation_13: {
    label: 'Prüfung, ob ein Wechsel des Energieträgers technisch möglich und wirtschaftlich sinnvoll ist.',
    type: WAERMEERZEUGER,
  },
  recommendation_14: {
    label: 'Eine umfassende Modernisierung der Heizungsanlage wird dringend empfohlen',
    type: WAERMEERZEUGER,
  },
  recommendation_15: {
    label:
      'Prüfung, ob eine nachträgliche Dämmung von zugänglichen Wärmeverteilungs- und Warmwasserleitungen sowie Armaturen möglich ist.',
    type: WAERMEVERTEILUNG_ABGABE,
  },
  recommendation_16: {
    label:
      'Prüfung, ob eine Nachrüstpflicht gemäß GEG § 69 (2) für die nachträgliche Dämmung von zugängigen Wärmeverteilungs- und Warmwasserleitungen sowie Armaturen in unbeheizten Räumen besteht .',
    type: WAERMEVERTEILUNG_ABGABE,
  },
};

export const propertyTypeOptions: OptionsType[] = [
  { id: '1', value: '1', label: 'Einfamilienhaus' },
  // { id: '2', value: '10', label: 'Einfamilienhaus mit Einliegerwohnung' },
  { id: '3', value: '4', label: 'Zweifamilienhaus' },
  { id: '4', value: '7', label: 'Mehrfamilienhaus' },
  { id: '5', value: '8', label: 'Wohn- und Geschäftshaus wohnwirtschaftlicher Teil' },
  // { id: '6', value: '9', label: 'Sonstiges Wohngebäude' },
];

export const contactPersonStatusOptions: OptionsType[] = [
  { id: '1', value: 'Eigentümer', label: 'Eigentümer' },
  { id: '2', value: 'Mieter', label: 'Mieter' },
  { id: '3', value: 'Vermittler', label: 'Vermittler / Makler' },
  { id: '4', value: 'Hausmeister', label: 'Hausmeister' },
  { id: '5', value: 'Käufer', label: 'Käufer' },
  { id: '6', value: 'Sonstiges', label: 'Sonstiges' },
  { id: '7', value: 'Darlehensnehmer', label: 'Darlehensnehmer' },
];

export const basementOptions: GraphicalSelectOption[] = [
  {
    id: '2',
    label: `Ja, beheizt`,
    icon: <YesHeatedIcon />,
  },
  {
    id: '1',
    label: 'Ja, unbeheizt',
    icon: <YesNotHeatedIcon />,
  },
  {
    id: '3',
    label: `Nein`,
    icon: <NoIcon />,
  },
];

export const coolingOptions: GraphicalSelectOption[] = [
  {
    id: '2',
    label: `Ja`,
    icon: <Cooling />,
  },
  {
    id: '3',
    label: 'Nein',
    icon: <NoCooling />,
  },
];

export const solarThermalSupportOptions: OptionsType[] = [
  {
    id: '1',
    label: `Solarthermie zur WW-Unterstützung`,
    value: 'SUPPORTS_WARM_WATER',
  },
  {
    id: '2',
    label: `Solarthermie zur HZ-Unterstützung`,
    value: 'SUPPORTS_HEATING',
  },
  {
    id: '3',
    label: `Solarthermie zur HZ- und WW-Unterstützung`,
    value: 'SUPPORTS_BOTH',
  },
];

export const livingSpaceOptions = (livingSpace: number): OptionsType[] => {
  return [
    {
      id: '1',
      label: `Gewerbeanteil bis 10% entspricht max. ${(livingSpace * 0.1).toFixed(1)} m2`,
    },
    {
      id: '2',
      label: `Gewerbeanteil über 10% entspricht mehr als ${(livingSpace * 0.1).toFixed(1)} m2`,
      error: true,
    },
  ];
};

export const livingSpaceCalculationOptions: OptionsType[] = [
  {
    id: '1',
    label: `Ja, eine prüffähige Wohnflächenberechnung ist vorhanden`,
  },
  {
    id: '2',
    label: `Ja, eine prüffähige Wohnflächenberechnung wird aber zu einem späteren Zeitpunkt hochgeladen.`,
  },
  {
    id: '3',
    label: `Nein, keine prüffähigen Nachweise vorhanden.`,
    error: true,
  },
];

export const evidenceAvailabilityOptions: OptionsType[] = [
  {
    id: '1',
    label: 'Ja',
  },
  {
    id: '2',
    label: `Nein, aber diese Unterlagen können nachgereicht werden.`,
  },
  {
    id: '3',
    label: `Nein, es sind keine Unterlagen vorhanden.`,
    error: true,
  },
];

export const areWindowsRenewedOptions: OptionsType[] = [
  { id: '1', value: 'YES', label: 'ja' },
  { id: '2', value: 'PARTIALLY', label: 'ja, teilweise' },
  { id: '3', value: 'NO', label: 'nein' },
];

export const nextSystemTypeOptions: OptionsType[] = [
  { id: '1', label: 'weiteres Heizsystem' },
  { id: '2', label: 'weiteres Warmwassersystem' },
  { id: '3', label: 'kein weiteres System' },
];

export const separateDhwSystemOptions: OptionsType[] = [
  {
    id: '1',
    label: 'Der Warmwasserverbrauch ist unbekannt',
  },
  {
    id: '2',
    label: 'Der Warmwasserverbrauch ist  bekannt als Brennstoffmenge',
  },
  {
    id: '3',
    label: 'Der Warmwasserverbrauch ist  bekannt als Wassermenge und Wassertemperatur',
  },
  { id: '4', label: 'über ein separates System' },
];

export const hotWaterSystemQueryOptions: OptionsType[] = [
  {
    id: '1',
    label: 'ein Heizungssystem,  und der Warmwasseranteil ist unbekannt',
  },
  {
    id: '2',
    label: 'ein Heizungssystem,  und der Warmwasseranteil-Anteil ist  bekannt als Brennstoffmenge',
  },
  {
    id: '3',
    label: 'ein Heizungssystem, und der Warmwasseranteil-Anteil ist bekannt als Wassermenge',
  },
  {
    id: '4',
    label: 'über ein separates System',
  },
];

export const whatWasRenovatedInHeatingSystemOptions: OptionsType[] = [
  { id: '1', label: 'Nur der Kessel wurde erneuert' },
  {
    id: '2',
    label: 'Die gesamte Anlage wurde ausgetauscht ggfs. inkl. Energieträgerwechsel',
    error: true,
  },
];

export enum ConstructionType {
  STORAGE_HEATER_NIGHT = 'STORAGE_HEATER_NIGHT',
  CENTRAL_ELECTRIC_STORAGE = 'CENTRAL_ELECTRIC_STORAGE',
  DIRECT_HEATING = 'DIRECT_HEATING',
  HEAT_PUMP_EXTERNAL = 'HEAT_PUMP_EXTERNAL',
  GEOTHERMAL_ENERGY = 'GEOTHERMAL_ENERGY',
  ELECTRIC_INSTANT_HEATER = 'ELECTRIC_INSTANT_HEATER',
  ELECTRIC_STORAGE_HEATER = 'ELECTRIC_STORAGE_HEATER',
}

export const electricityOptions: OptionsType[] = [
  {
    id: ConstructionType.STORAGE_HEATER_NIGHT,
    label: `Nachtspeicherofen`,
    value: ConstructionType.STORAGE_HEATER_NIGHT,
  },
  {
    id: ConstructionType.CENTRAL_ELECTRIC_STORAGE,
    label: `Zentraler elektrischer Speicher`,
    value: ConstructionType.CENTRAL_ELECTRIC_STORAGE,
  },
  {
    id: ConstructionType.DIRECT_HEATING,
    label: `Elektro-Direktheizung (z.B. Infrarotheizung)`,
    value: ConstructionType.DIRECT_HEATING,
  },
  {
    id: ConstructionType.HEAT_PUMP_EXTERNAL,
    label: `Wärmepumpe - Außenluft  / Umweltenergie - Luft`,
    value: ConstructionType.HEAT_PUMP_EXTERNAL,
  },
  {
    id: ConstructionType.GEOTHERMAL_ENERGY,
    label: `Wärmepumpe - Erdreich / Grundwasser (Geothermie)`,
    value: ConstructionType.GEOTHERMAL_ENERGY,
  },
  {
    id: ConstructionType.ELECTRIC_INSTANT_HEATER,
    label: `Elektrischer Durchlauferhitzer`,
    value: ConstructionType.ELECTRIC_INSTANT_HEATER,
  },

  {
    id: ConstructionType.ELECTRIC_STORAGE_HEATER,
    label: `Elektrischer Kleinspeicher`,
    value: ConstructionType.ELECTRIC_STORAGE_HEATER,
  },
];

export const localDistrictHeatingOptions: OptionsType[] = [
  {
    id: '1',
    label: `Nah-/Fernwärme aus KWK - fossiler Brennstoff (Stein-/Braunkohle)`,
  },
  {
    id: '2',
    label: `Nah-/Fernwärme aus KWK - erneuerbarer Brennstoff`,
  },
  {
    id: '3',
    label: `Nah-/Fernwärme aus Heizwerken - fossiler Brennstoff (Stein-/Braunkohle)`,
  },
  {
    id: '4',
    label: `Nah-/Fernwärme aus Heizwerken - erneuerbarer Brennstoff`,
  },
  {
    id: '5',
    label: `Nah-/Fernwärme aus KWK - fossiler Brennstoff (Gasförmige und flüssige Brennstoffe)`,
  },
  {
    id: '6',
    label: `Nah-/Fernwärme aus Heizwerken - fossiler Brennstoff (Gasförmige und flüssige Brennstoffe)`,
  },
];

export const yesOrNo: OptionsType[] = [
  { id: '1', label: 'Ja' },
  { id: '2', label: 'Nein' },
];

export enum YesNoOptionValue {
  YES = '1',
  NO = '2',
}

export const yesOrNoWithError: OptionsType[] = [
  { id: '1', label: 'Ja' },
  { id: '2', label: 'Nein', error: true },
];

export enum FuelUnits {
  KWH = 'KWH',
  KG = 'KG',
  MWH = 'MWH',
  LITER = 'LITER',
  M3 = 'M3',
  RM = 'RM',
  SRM = 'SRM',
}

export const availableFuelUnits: OptionsType[] = [
  { id: '1', value: 'KWH', label: `kWh` },
  { id: '2', value: 'KG', label: `kg` },
  { id: '3', value: 'MWH', label: `MWh` },
  { id: '4', value: 'LITER', label: `Liter` },
  { id: '5', value: 'M3', label: `m³` },
  { id: '6', value: 'RM', label: `Rm` },
  { id: '7', value: 'SRM', label: `SRm` },
];

export enum Fuels {
  HEATING_OIL_EL = 'HEIZOEL_EL',
  NATURAL_GAS_H = 'ERDGAS_H',
  NATURAL_GAS_L = 'ERDGAS_L',
  LIQUID_GAS = 'FLUESSIGGAS',
  BROWN_COAL = 'BRAUNKOHLE',
  HARD_COAL = 'STEINKOHLE',
  WOOD = 'HOLZ',
  WOOD_PELLETS = 'HOLZ_PELLETS',
  WOOD_CHIPS = 'HOLZHACKSCHNITZEL',
  GENERAL_POWER_MIX = 'ALLGEMEIN_STROMMIX',
  BIO_GAS = 'BIOGAS',
  BIO_OIL = 'BIOOEL',
  NAH_FERN_KWK_FOSSIL = 'NAH_FERN_KWK_FOSSIL',
  NAH_FERN_KWK_FOSSIL_FLUESSIG = 'NAH_FERN_KWK_FOSSIL_FLUESSIG',
  NAH_FERN_KWK_ERNEUERBAR = 'NAH_FERN_KWK_ERNEUERBAR',
  NAH_FERN_HEIZWERK_FOSSIL = 'NAH_FERN_HEIZWERK_FOSSIL',
  NAH_FERN_HEIZWERK_FOSSIL_FLUESSIG = 'NAH_FERN_HEIZWERK_FOSSIL_FLUESSIG',
  NAH_FERN_HEIZWERK_ERNEUERBAR = 'NAH_FERN_HEIZWERK_ERNEUERBAR',
}

export type AvailableFuelsType = OptionsType & { units: string[] };

export const availableFuels: AvailableFuelsType[] = [
  { id: '1', value: 'HEIZOEL_EL', label: `Heizöl EL`, units: ['KWH', 'LITER'] },
  { id: '2', value: 'ERDGAS_H', label: `Erdgas H / Erdgas E`, units: ['KWH', 'M3'] },
  { id: '3', value: 'ERDGAS_L', label: `Erdgas L / Erdgas LL`, units: ['KWH', 'M3'] },
  {
    id: '4',
    value: 'FLUESSIGGAS',
    label: 'Flüssiggas',
    units: ['KWH', 'KG', 'M3', 'LITER'],
  },
  { id: '5', value: 'BRAUNKOHLE', label: `Braunkohle`, units: ['KWH', 'KG'] },
  { id: '6', value: 'STEINKOHLE', label: `Steinkohle`, units: ['KWH', 'KG'] },
  { id: '7', value: 'HOLZ', label: `Holz (lufttrocken)`, units: ['KWH', 'KG', 'SRM', 'RM'] },
  { id: '8', value: 'HOLZ_PELLETS', label: `Holzpellets`, units: ['KWH', 'KG', 'SRM'] },
  { id: '9', value: 'HOLZHACKSCHNITZEL', label: `Holzhackschnitzel`, units: ['KWH', 'SRM'] },
  { id: '10', value: 'ALLGEMEIN_STROMMIX', label: 'Strom', units: ['KWH'] },
  { id: '11', value: 'BIOGAS', label: `Bio-Erdgas / Bio-Flüssiggas`, units: ['KWH', 'M3'] },
  { id: '12', value: 'BIOOEL', label: `Bio-Heizöl`, units: ['KWH', 'LITER'] },
  { id: '13', value: '13', label: 'Nah-/Fernwärme', units: ['KWH'] },
];

export const fuelUnitsData = {
  1: {
    dropdownPlaceholder: 'Heizöl EL',
    hintTitle: 'Angabe in Liter:',
    hintContents: (
      <>
        <p>
          Die verbrauchte Energiemenge in Liter findet man auf Tankquittungen. Sollten keine Verbrauchsabrechnungen des
          Energieversorgers vorliegen, kann den Verbrauch in Litern wie folgend ermitteln: Abgeschätzte Füllmenge des
          Tanks vor der ersten Tanklieferung, abzüglich der aktuellen Tankmenge plus den getankten Mengen gemäß
          Tankquittungen des entsprechend Abrechnungszeitraums ergibt den Verbrauch.
        </p>
        <p>Umrechnung Brennwert / Heizwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs).
        </p>
        <p>
          Dieser wird aus der gelieferten Menge Erdöl in Litern wie folgt berechnet: Brennwert (Thermische Energie) =
          Erdöl [Liter] x z-Zahl x Brennwertfaktor [ kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  2: {
    dropdownPlaceholder: 'Erdgas H / Erdgas E',
    hintTitle: 'Angabe in m³ (Kubikmeter):',
    hintContents: (
      <>
        <p>Die verbrauchte Energiemenge in Kubikmeter Gas findet man auf den Abrechnungen des Energieversorgers.</p>
        <p>Angabe in Brennwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs). Dieser wird aus der gelieferten Menge Gas m³ wie folgt berechnet: Brennwert
          (Thermische Energie) = Gas [ m³] x z-Zahl x Brennwertfaktor [ kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  3: {
    dropdownPlaceholder: 'Erdgas L / Erdgas LL',
    hintTitle: 'Angabe in m³ (Kubikmeter):',
    hintContents: (
      <>
        <p>Die verbrauchte Energiemenge in Kubikmeter Gas findet man auf den Abrechnungen des Energieversorgers.</p>
        <p>Angabe in Brennwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs). Dieser wird aus der gelieferten Menge Gas m³ wie folgt berechnet: Brennwert
          (Thermische Energie) = Gas [ m³] x z-Zahl x Brennwertfaktor [ kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  4: {
    dropdownPlaceholder: 'Flüssiggas',
    hintTitle: 'Angabe in m³ (Kubikmeter):',
    hintContents: (
      <>
        <p>Die verbrauchte Energiemenge in Kubikmeter Gas findet man auf den Abrechnungen des Energieversorgers.</p>
        <p>Angabe in Brennwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs). Dieser wird aus der gelieferten Menge Gas m³ wie folgt berechnet: Brennwert
          (Thermische Energie) = Gas [ m³] x z-Zahl x Brennwertfaktor [kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  5: {
    dropdownPlaceholder: 'Braunkohle',
    hintTitle: 'Umrechnungstabelle Brennwert zu Heizwert',
    hintContents: (
      <>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  6: {
    dropdownPlaceholder: 'Steinkohle',
    hintTitle: 'Umrechnungstabelle Brennwert zu Heizwert',
    hintContents: (
      <>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  7: {
    dropdownPlaceholder: 'Holz (lufttrocken)',
    hintTitle: 'Umrechnungstabelle Brennwert zu Heizwert',
    hintContents: (
      <>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  8: {
    dropdownPlaceholder: 'Holzpellets',
    hintTitle: 'Umrechnung von metrischen Raummaße für Holzpellets:',
    hintContents: (
      <>
        <p>Bitte beachten, dass auch die Verbräuche von Holzpellets in kWh Heizwert anzugeben sind.</p>
        <p>Die verwendeten Holzarten haben zum Teil stark unterschiedliche Brennwerte.</p>
        <p>
          Eine Tabelle zum Umrechnen Ihrer metrischen Raummaße, wie Raummeter (Rm), Schüttraummeter (SRm) und den
          Heizwerten der unterschiedlichen Holzarten findet man hier: Umrechentabelle_Holz_Heizwert
        </p>
      </>
    ),
  },

  9: {
    dropdownPlaceholder: 'Holzhackschnitzel',
    hintTitle: 'Warum wird nach der Holzart gefragt?',
    hintContents: (
      <>
        <p>
          Holzarten haben unterschiedliche Brennwerte. Sollte die Holzart nicht bekannt sein, dann bitte Laubholz (hart)
          verwenden
        </p>
        <p>Umrechnung von metrischen Raummaße für Holzhackschnitzel: </p>
        <p>Bitte beachten, dass auch die Verbräuche von Holzhackschnitzel in kWh Heizwert anzugeben sind.</p>
        <p>Die verwendeten Holzarten haben zum Teil stark unterschiedliche Brennwerte.</p>
        <p>
          Eine Tabelle zum Umrechnen Ihrer metrischen Raummaße, wie Raummeter (Rm), Schüttraummeter (SRm) und den
          Heizwerten der unterschiedlichen Holzarten findet man hier: Umrechentabelle_Holz_Heizwert
        </p>
        <p>Wie kann man den Heizwert der verwendeten Holzart ermitteln?</p>
        <p>Den Heizwert der verwendeten Holzart kann man hier (Umrechentabelle_Holz_Heizwert) ermitteln</p>
      </>
    ),
  },

  10: {
    dropdownPlaceholder: 'Strom',
  },

  11: {
    dropdownPlaceholder: 'Bio-Erdgas',
    hintTitle: 'Angabe in m³ (Kubikmeter):',
    hintContents: (
      <>
        <p>Die verbrauchte Energiemenge in Kubikmeter Gas findet man auf den Abrechnungen des Energieversorgers.</p>
        <p>Angabe in Brennwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs). Dieser wird aus der gelieferten Menge Gas m³ wie folgt berechnet: Brennwert
          (Thermische Energie) = Gas [ m³] x z-Zahl x Brennwertfaktor [ kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  12: {
    dropdownPlaceholder: 'Bio-Flüssiggas',
    hintTitle: 'Angabe in m³ (Kubikmeter):',
    hintContents: (
      <>
        <p>Die verbrauchte Energiemenge in Kubikmeter Gas findet man auf den Abrechnungen des Energieversorgers.</p>
        <p>Angabe in Brennwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs). Dieser wird aus der gelieferten Menge Gas m³ wie folgt berechnet: Brennwert
          (Thermische Energie) = Gas [ m³] x z-Zahl x Brennwertfaktor [kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  13: {
    dropdownPlaceholder: 'Bio-Heizöl',
    hintTitle: 'Angabe in Liter:',
    hintContents: (
      <>
        <p>
          Die verbrauchte Energiemenge in Liter findet man auf Tankquittungen. Sollten keine Verbrauchsabrechnungen des
          Energieversorgers vorliegen, kann den Verbrauch in Litern wie folgend ermitteln: Abgeschätzte Füllmenge des
          Tanks vor der ersten Tanklieferung, abzüglich der aktuellen Tankmenge plus den getankten Mengen gemäß
          Tankquittungen des entsprechend Abrechnungszeitraums ergibt den Verbrauch.
        </p>
        <p>Umrechnung Brennwert / Heizwert in kWh:</p>
        <p>
          Der Verbrauch (auch thermische Energie genannt) auf der Rechnung des Energieversorgers steht, bezieht sich in
          der Regel auf den Brennwert (Hs).
        </p>
        <p>
          Dieser wird aus der gelieferten Menge Erdöl in Litern wie folgt berechnet: Brennwert (Thermische Energie) =
          Erdöl [Liter] x z-Zahl x Brennwertfaktor [ kWh/m³]
        </p>
        <p>
          Eine Umrechnungstabelle Brennwert zu Heizwert findet man hier:{' '}
          <a href="https://portal.energieausweis48.de/converter">https://portal.energieausweis48.de/converter</a>
        </p>
      </>
    ),
  },

  14: { dropdownPlaceholder: 'Nah-/Fernwärme' },
};

export const commercialSpaceHintText = {
  1: {
    title: '',
    contents:
      'Sollte sich bis 10 % Gewerbe  im Gebäude befinden, bitte die Anzahl der Gewerbeeinheiten zu den Wohneinheiten hinzuzählen und die beheizten Nutzflächen zur Wohnfläche addieren.',
  },
  2: {
    title: '',
    contents:
      'Sollte sich mehr als 10 % wohnungsähnliches  Gewerbe im Gebäude befinden, bitte die Anzahl der Gewerbeeinheiten zu den Wohneinheiten hinzuzählen und die beheizten Nutzflächen zur Wohnfläche addieren.',
  },
  3: {
    title: '',
    contents: (
      <>
        <p>
          Sollte sich mehr als 10% nicht-wohnungsähnliches Gewerbe im Gebäude befinden dann kann nur für den
          wohnwirtschaftlich genutzten Gebäudeteil ein Ausweis erstellt werden.
        </p>
        <p>Die notwendigen Berechnungen und Anpassungen können jedoch nur durch den Aussteller durchgeführt werden.</p>
        <p>
          Hierzu bitte unter Gebäudeteil: “wohnwirtschaftlich genutzter Gebäudeteil” wählen. Alle weiteren Anpassungen
          werden durch den Aussteller vorgenommen.
        </p>
      </>
    ),
  },
  5: {
    title: '',
    contents:
      'Es tut uns leid, für Gebäude mit mehr als 90% Gewerbeanteil können wir leider kein Zertifikat ausstellen.',
  },
};

export const commercialSpaceOptions: OptionsType[] = [
  {
    id: '1',
    label: 'nein, bzw. bis 10 % Gewerbeanteil',
    value: 'UP_TO_TEN_PERCENT',
  },
  {
    id: '2',
    label: 'Ja, 10-50% Gewerbeanteil und wohnungsähnlich',
    value: 'UP_TO_50_PERCENT_AND_SIMILAR_TO_APARTMENT',
  },
  {
    id: '3',
    label: 'Ja, 10-50% und nicht wohnungsähnlich',
    value: 'BETWEEN_10_AND_50_PERCENT_AND_NOT_SIMILAR_TO_APARTMENT',
  },
  {
    id: '4',
    label: 'Ja, 50-90% Gewerbeanteil',
    value: 'BETWEEN_50_AND_90_PERCENT',
  },
  {
    id: '5',
    label: 'Ja, über 90% Gewerbeanteil',
    value: '',
    error: true,
  },
];
